<template>
    <div class="card">
        <div class="card-body">
            <div class="text-center mb-3">
                <i class="icon-mail5 icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"></i>
                <h5 class="mb-0">{{ $t('auth.registration.title') }}</h5>
                <span class="d-block text-muted">{{ $t('auth.registration.send_email_code_description') }}</span>
            </div>

            <form @submit.prevent="sendCode">
                <FormGroup :label="$t('auth.fields.email')">
                    <Input type="email" :placeholder="$t('auth.fields.email')" v-model="emailValue"/>
                </FormGroup>

                <p>
                    {{ $t('auth.registration.has_account') }}
                    <router-link :to="{ name: 'AuthenticationPage', query: $route.query }">{{ $t('auth.registration.login_now') }}</router-link>
                </p>

                <div class="btn-group-justified">
                    <Button size="sm" type="submit" color="primary" class="ml-1">{{ $t('auth.buttons.send') }}<i class="icon-circle-right2 ml-2"></i></Button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "SendEmailCodeCard",
    components: {
        FormGroup,
        Input,
        Button,
    },
    props: ['email'],
    emits: ['code-sent'],
    data() {
        return {
            emailValue: this.email,
        }
    },
    methods: {
        async sendCode() {
            await httpClient.post('/registration/send-email-code', {
                recipient_address: this.emailValue,
            });

            new MessageNotificator().success(this.$t('auth.registration.send_email_code_success'));
            this.$emit('code-sent', this.emailValue);
        },
    },
}
</script>
